(function() {

  const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(header_operlay){
    document.body.classList.add('header-overlay');
  }   

})();



// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();
})();


// Faq page wirkung img hide show

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-faq-section]').forEach(section => {
    const detailsEls = section.querySelectorAll('details');
    const images = section.querySelectorAll('.faq-image');

    detailsEls.forEach(details => {
      details.addEventListener('toggle', () => {

        // Only when THIS details is opened
        if (!details.open) return;

        const blockId = details.id.replace('Details-', '').split('-')[0];

        // Close other FAQs in SAME section
        detailsEls.forEach(d => {
          if (d !== details) d.removeAttribute('open');
        });

        // Hide images only in this section
        images.forEach(img => {
          img.style.display = 'none';
        });

        // Show related image
        const activeImg = section.querySelector(
          `.faq-image[data-block-id="${blockId}"]`
        );

        if (activeImg) {
          activeImg.style.display = 'block';
        }
      });
    });
  });
});

// autosize
function autosize() {
    const textareas = document.querySelectorAll('.autosize');

    textareas.forEach(textarea => {
        textarea.setAttribute('rows', 1);
        resize(textarea);

        textarea.addEventListener('input', () => resize(textarea));
    });

    function resize(textarea) {
        textarea.style.height = '41px';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}

autosize();



// hotsport start
function hosport_click(item) {
  item.addEventListener("click", (event) => {
    console.log("eee")
    event.stopPropagation(); // Prevent body click event from firing immediately
    
    let hide_content = document.querySelectorAll("[data-host-port-content]");
    let targetSelector = event.target.getAttribute('data-hotsport-click');
    let targetContent = document.querySelector(targetSelector);

    if (targetContent) {
      if (targetContent.classList.contains('hidden')) {
        // Hide all other content
        hide_content.forEach(b => b.classList.add("hidden"));
        
        // Show the clicked content
        targetContent.classList.remove("hidden");
        targetContent.classList.add("show_spot");
        document.body.classList.add('overflow_hidden');
      } else {
        // Hide current content
        targetContent.classList.add("hidden");
        targetContent.classList.remove("show_spot");
        document.body.classList.remove('overflow_hidden');
      }
    }
  });
}

// Attach event to all elements with [data-hotsport-click]
document.querySelectorAll("[data-hotsport-click]").forEach(hosport_click);

// Body click to close content when clicking outside
document.body.addEventListener("click", (event) => {
  if (document.body.classList.contains("overflow_hidden")) {
    // Ignore clicks inside the currently open content
    if (!event.target.closest('.show_spot[data-host-port-content]')) {
      console.log("Closing content");

      document.querySelector('.show_spot[data-host-port-content]')?.classList.add("hidden");
      document.querySelector('.show_spot[data-host-port-content]')?.classList.remove("show_spot");
      document.body.classList.remove('overflow_hidden');
    }
  }
});


// hotsport end


//tab Featured collection
document
  .querySelectorAll(".tab-featured-collection-wrapper")
  .forEach((section) => {
    const tabNavItems = section.querySelectorAll(".tab-nav-title");
    const tabContents = section.querySelectorAll(".tabs-content-wrapper");

    if (!tabNavItems.length || !tabContents.length) return;

    function activateTab(tab) {
      const link = tab.querySelector("a");
      const targetId = link?.getAttribute("href");

      const target = Array.from(tabContents).find(
        (content) => `#${content.id}` === targetId
      );

      if (!target) return;

      tabNavItems.forEach((item) => {
        item.classList.toggle("active", item === tab);
      });

      tabContents.forEach((content) => {
        content.style.display = content === target ? "block" : "none";
      });

      // Einen vorhandenen Slider nach dem Einblenden neu berechnen.
      target.querySelectorAll(".swiper").forEach((slider) => {
        if (slider.swiper) {
          slider.swiper.update();
        }
      });
    }

    tabNavItems.forEach((tab) => {
      const link = tab.querySelector("a");
      if (!link) return;

      link.addEventListener("click", (event) => {
        event.preventDefault();
        activateTab(tab);
      });
    });

    activateTab(tabNavItems[0]);
  });
//tab Featured collection end



  (function () {
    const section = document.getElementById("read-more-{{ section.id }}");
    if (!section) return;

    const button = section.querySelector(".read-toggle");

    button.addEventListener("click", function () {
      section.classList.toggle("expanded");

      if (section.classList.contains("expanded")) {
        button.textContent = "{{ section.settings.read_less_label }}";
      } else {
        button.textContent = "{{ section.settings.read_more_label }}";
      }
    });
  })();


// 

// const togglebtns = document.querySelectorAll('[togglebtn]');
// const pdpGrid = document.querySelector('[productgridcontainer]');
// if(togglebtns){
//   togglebtns.forEach(btn => {
//     btn.addEventListener("click", function (e) {
//       const image_show = btn.getAttribute('image_show');
//       // console.log("image_show",image_show)
//       document.querySelector('[togglebtn].active_btn')
//       btn.classList.add('active_btn');
//       if(image_show == 'true'){
//         pdpGrid.classList.add('image_show');        
//       }else{
//         pdpGrid.classList.remove('image_show');        
//       }
//     });
//   });
// }

const togglebtns = document.querySelectorAll('[togglebtn]');
const pdpGrid = document.querySelector('[productgridcontainer]');

if (togglebtns.length && pdpGrid) {
  togglebtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const imageShow = btn.getAttribute('image_show') === 'true';

      // remove active class from all buttons
      togglebtns.forEach(b => b.classList.remove('active_btn'));

      // add active class to clicked button
      btn.classList.add('active_btn');

      // toggle grid class
      pdpGrid.classList.toggle('image_show', imageShow);
    });
  });
}

const btn_close = document.querySelectorAll('[filter_closebtn]');
btn_close.forEach(btn => {
  btn.addEventListener('click', () => {
    // console.log("11")
    document.querySelector('[filter_close_btn]').click();
  });
});


// function smoothScroll(target) {
//   const header = document.querySelector('sticky-header');
//   const header_height = (header ? header.offsetHeight + 10 : 150);

//   const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;

//   window.scrollTo({
//     top: targetPosition - header_height,
//     behavior: "smooth"
//   });
// }

function smoothScroll(target) {
  const header = document.querySelector('sticky-header');
  const header_height = header ? header.offsetHeight + 10 : 150;

  const element = typeof target === "string" ? document.querySelector(target) : target;
  if (!element) return;

  const targetPosition = element.getBoundingClientRect().top + window.pageYOffset;

  window.scrollTo({
    top: targetPosition - header_height,
    behavior: "smooth"
  });
}

var items = document.querySelectorAll('[scroll]');
items.forEach(item => {
  item.addEventListener('click', () => {
    var attr = item.getAttribute('scroll');
    smoothScroll(attr);
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//   const trafficlyMessage = document.getElementById("trafficly-message");
//   const trafficlyCount = document.getElementById("trafficly-count");

//   if (trafficlyMessage && trafficlyCount) {
//     // const countText = trafficlyCount.textContent.trim();
//     // const count = parseInt(countText, 10);
//     const count = parseInt(trafficlyCount.innerText)

//     // Hide if not a valid number OR number is less than 50
//     console.log("count",count,trafficlyCount.innerText)
//     if (isNaN(count) || count < 50) {
//       trafficlyMessage.closest('.shopify-app-block')?.classList.add("hidden");
//     }
//   }
// });


document.addEventListener("DOMContentLoaded", function () {

  const trafficlyCount_ = document.getElementById("trafficly-count");

  // if (!trafficlyMessage || !trafficlyCount) return;

  function checkTrafficlyCount() {
      const trafficlyMessage = document.getElementById("trafficly-message");
     const trafficlyCount = document.getElementById("trafficly-count");
     
  if (!trafficlyMessage) return;
    const count = parseInt(trafficlyCount.innerText.trim(), 10);

    console.log("count:", count, "text:", trafficlyCount.innerText);

    if (isNaN(count) || count < 50) {
      trafficlyMessage
        .closest(".shopify-app-block")
        ?.classList.add("hidden");
    } else {
      trafficlyMessage
        .closest(".shopify-app-block")
        ?.classList.remove("hidden");
    }
  }

  // Initial check
  checkTrafficlyCount();

  // Watch for innerHTML/text changes
  const observer = new MutationObserver(function () {
    checkTrafficlyCount();
  });

  if(trafficlyCount_){

    observer.observe(trafficlyCount_, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
});